module.exports = __webpack_public_path__ + "static/media/water_pump_setup.55161cec.jpg";